import { h, defineComponent, SetupContext } from 'vue';
import { ValidationError } from '@/entities/validation';
import { SelectOptions, SelectOptionsWithId, SetterCallback } from '@/ui/types';
import { Field, FieldProps } from './Field';
import { FreeTagInput, FreeTagInputProps } from '../controls/FreeTagInput';

export interface FreeTagFieldProps<T = number> {
  name: string;
  label: string;
  tooltipText?: string;
  value: T[];
  data?: SelectOptions<string|number> | SelectOptionsWithId<string|number>;
  icon?: string;
  addLabel?: string;
  addLabelEmptyValue?: string;
  required: boolean;
  placeholder: string;
  disabled: boolean;
  errors: ValidationError[];
  hideLabel?: boolean;
  horizontal?: boolean;
  autocomplete?: boolean;
  openOnFocus?: boolean;
}

export const FreeTagField = defineComponent<FreeTagFieldProps>({
  name: 'FreeTagField',

  props: [
    'name', 'label', 'value', 'icon', 'required', 'placeholder', 'options', 'errors', 'disabled',
    'hideLabel', 'horizontal', 'autocomplete', 'data', 'openOnFocus', 'addLabel', 'tooltipText',
    'addLabelEmptyValue',
  ],
  setup(props, context: SetupContext) {
    return function render() {
      const fieldProps: FieldProps = {
        label: props.label,
        name: props.name,
        required: props.required,
        errors: props.errors,
        hideLabel: props.hideLabel,
        horizontal: props.horizontal,
        tooltipText: props.tooltipText,
      };

      const tagInputProps: FreeTagInputProps<string|number> = {
        data: props.data,
        value: props.value,
        disabled: props.disabled,
        icon: props.icon,
        placeholder: props.placeholder,
        autocomplete: props.autocomplete,
        openOnFocus: props.openOnFocus,
        addLabel: props.addLabel,
        addLabelEmptyValue: props.addLabelEmptyValue,
      };

      return h(Field, { props: fieldProps }, [
        h(FreeTagInput, {
          props: tagInputProps,
          ref: 'freeTagInput',
          scopedSlots: context.slots,
          on: {
            input: (value: unknown[]) => {
              context.emit('input', value);
            },
          },
        }),
      ]);
    };
  },
});

export function freeTagField<T>(props: FreeTagFieldProps<T>, input: SetterCallback<T[]>) {
  return h(FreeTagField, {
    props,
    on: { input },
  });
}
